export default __webpack_public_path__ + "static/media/tuto-step-3.358daf56.gif";